import get from "lodash/get";

const translatableKeyReferences = ["degreeLevel", "year"];
const translationsNamespaceKeyMap = {
    year: ["undergraduateYears", "postgraduateYears"],
};

const _hasTranslatableKeyReferences = (introMessage) => {
    const introMessageText = get(introMessage, "text", "") || "";

    const hasReference = translatableKeyReferences.some((key) => {
        const keyValue = get(introMessage, `sender.${key}`);
        return keyValue && introMessageText.includes(keyValue);
    });

    return hasReference;
};

const _buildNamespaceKey = (key, keyValue) => {
    const rootKey = translationsNamespaceKeyMap[key];
    const deepKey = key === "year" ? keyValue.replace(/ +/g, "") : keyValue.toLowerCase();

    if (!rootKey) {
        return deepKey;
    }

    if (Array.isArray(rootKey)) {
        return rootKey.map((root) =>
            key === "year" ? `mentorCard:${root}.${deepKey}` : `${root}.${deepKey}`,
        );
    }

    return key === "year" ? `mentorCard:${rootKey}.${deepKey}` : `${rootKey}.${deepKey}`;
};

/**
 * Translates translatable strings of the raw introMessage text
 * @param {object} introMessage
 * @param {function} t translation function
 * @returns translatedIntroMessageObject
 */
export default function translateIntroMessage(introMessage, t) {
    try {
        if (!_hasTranslatableKeyReferences(introMessage) || !t) {
            return introMessage;
        }

        let introMessageText = get(introMessage, "text", "") || "";

        translatableKeyReferences.forEach((key) => {
            const keyValue = get(introMessage, `sender.${key}`);

            if (keyValue && introMessageText.includes(keyValue)) {
                const sourceKey = _buildNamespaceKey(key, keyValue);

                // sourceKey can be a string | array.
                // see https://www.i18next.com/overview/api#t
                const translatedValue = t(sourceKey, keyValue);
                introMessageText = introMessageText.replace(keyValue, translatedValue);
            }
        });

        return {...introMessage, text: introMessageText};
    } catch (e) {
        return introMessage;
    }
}
